module.exports = __webpack_public_path__ + "static/banner-bg-f6010ac722a91064c946b55882eba1c0.jpg";